<template>
    <div class="na-form">
        <div v-if="ratingTypeGroupDetail" class="left">

            <DxTabPanel>
                <DxItem :title="tx.TabBasicData">

                    <div class="dx-fieldset">
                        <div class="dx-field">
                            <div class="dx-field-label">Id:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='ratingTypeGroupDetail.RtgId' :readOnly="true" />
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldName}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='ratingTypeGroupDetail.RtgName' />
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldCaption}}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='ratingTypeGroupDetail.RtgCaption' />
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldDesc}}:</div>
                            <div class="dx-field-value">
                                <DxHtmlEditor class="html-dx-field" v-model:value="ratingTypeGroupDetail.RtgDescription"
                                              :value-type="editorValueType">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem :accepted-values="sizeValues"
                                                name="size" />
                                        <DxItem :accepted-values="fontValues"
                                                name="font" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="link" />
                                        <DxItem name="image" />
                                        <DxItem name="separator" />
                                        <DxItem name="clear" />
                                        <DxItem name="codeBlock" />
                                        <DxItem name="blockquote" />
                                        <DxItem name="separator" />
                                        <DxItem name="insertTable" />
                                        <DxItem name="deleteTable" />
                                        <DxItem name="insertRowAbove" />
                                        <DxItem name="insertRowBelow" />
                                        <DxItem name="deleteRow" />
                                        <DxItem name="insertColumnLeft" />
                                        <DxItem name="insertColumnRight" />
                                        <DxItem name="deleteColumn" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldEnabled}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='ratingTypeGroupDetail.RtgEnabled' />
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRtgIsPublic}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='ratingTypeGroupDetail.RtgIsPublic' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeExGrp}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="GrpName" :dataSource="groupList" valueExpr="GrpId" v-model:value="ratingTypeGroupDetail.GrpId" :showClearButton="true">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeComp}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="RouName" :dataSource="roundList" valueExpr="RouId" v-model:value="ratingTypeGroupDetail.RouId" :showClearButton="true">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeTty}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="TtyName" :dataSource="ttyList" valueExpr="TtyId" v-model:value="ratingTypeGroupDetail.TtyId" :showClearButton="true">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="ratingTypeGroupDetail.TtyId > 0">
                            <div class="dx-field-label">{{tx.FieldRatingTypeStatus}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StatusName" :dataSource="statusList" valueExpr="StatusID" v-model:value="ratingTypeGroupDetail.StatusId" :showClearButton="true">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="!(ratingTypeGroupDetail.TtyId > 0)">
                            <div class="dx-field-label">{{tx.FieldRatingTypeStatusGroup}}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox displayExpr="StgName" :dataSource="statusGroupList" valueExpr="StgId" v-model:value="ratingTypeGroupDetail.StgId" :showClearButton="true">
                                </DxSelectBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeOverallQues}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='ratingTypeGroupDetail.RtgWithMainQuestion' />
                            </div>
                        </div>
                        <div class="dx-field" v-if="ratingTypeGroupDetail.RtgWithMainQuestion">
                            <div class="dx-field-label">{{tx.FieldRatingTypeOverallQuesTitle}}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='ratingTypeGroupDetail.RtgMainQuestionTitle' />
                            </div>
                        </div>
                        <div class="dx-field" v-if="ratingTypeGroupDetail.RtgWithMainQuestion">
                            <div class="dx-field-label">{{tx.FieldRatingTypeOverallQuesText}}:</div>
                            <div class="dx-field-value">
                                <DxHtmlEditor class="html-dx-field" v-model:value="ratingTypeGroupDetail.RtgMainQuestionText"
                                              :value-type="editorValueType">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem :accepted-values="sizeValues"
                                                name="size" />
                                        <DxItem :accepted-values="fontValues"
                                                name="font" />
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="link" />
                                        <DxItem name="image" />
                                        <DxItem name="separator" />
                                        <DxItem name="clear" />
                                        <DxItem name="codeBlock" />
                                        <DxItem name="blockquote" />
                                        <DxItem name="separator" />
                                        <DxItem name="insertTable" />
                                        <DxItem name="deleteTable" />
                                        <DxItem name="insertRowAbove" />
                                        <DxItem name="insertRowBelow" />
                                        <DxItem name="deleteRow" />
                                        <DxItem name="insertColumnLeft" />
                                        <DxItem name="insertColumnRight" />
                                        <DxItem name="deleteColumn" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeOverallCm}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='ratingTypeGroupDetail.RtgWithComment' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRtgIncludeOnlyEligableScores}}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='ratingTypeGroupDetail.RtgIncludeOnlyEligableScores' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeStart}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='ratingTypeGroupDetail.RtgStart' />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{tx.FieldRatingTypeEnd}}:</div>
                            <div class="dx-field-value">
                                <DxDateBox v-model:value='ratingTypeGroupDetail.RtgEnd' />
                            </div>
                        </div>
                    </div>
                </DxItem>
                <DxItem :title="tx.TabRights">
                    <DxDataGrid :data-source="accessList"
                                :key-expr="GrpId"
                                :filter-row-visible="true"
                                :row-alternation-enabled="true"
                                @row-updating="rowUpdating">
                        <DxEditing :allow-updating="true"
                                   :allow-adding="false"
                                   :allow-deleting="false"
                                   mode="cell" />
                        <DxColumn data-field="ObjName"
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="column.ColGroup"
                                  data-type="string" />
                        <DxColumn data-field="CanRead"
                                  :caption="column.ColRead"
                                  data-type="boolean" />
                        <DxColumn data-field="CanUpdate"
                                  :caption="column.ColEdit"
                                  data-type="boolean" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>
                </DxItem>
            </DxTabPanel>
            <div class="na-buttons-row">
                <div>
                    <DxButton :text="btn.BtnSave"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              styling-mode="contained"
                              @click="onSaveClick()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnDelete"
                              type="default"
                              styling-mode="contained"
                              @click="onDeleteClick()" />
                </div>
                <div>
                    <DxButton :text="btn.BtnCancel"
                              type="default"
                              styling-mode="outlined"
                              @click="onCloseClick()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    import { DxDataGrid, DxColumn, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid';
    import { DxTextBox, DxTextArea, DxDateBox } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import notify from 'devextreme/ui/notify';
    import '../assets/detailForm.less';
    import { confirm, alert } from "devextreme/ui/dialog";
    import $ from 'jquery';
    import { DxTabPanel } from 'devextreme-vue/tab-panel';
    import {
        DxHtmlEditor,
        DxToolbar,
        DxItem
    } from 'devextreme-vue/html-editor';
    import { DxCheckBox } from 'devextreme-vue/check-box';

    const baseUri = "WebApi.asmx/api/ratingTypeGroupService";
    export default {
        name: 'RatingTypeGroupDetail',
        components: {
            DxButton, DxTextBox, DxTextArea, DxTabPanel, DxItem, DxDataGrid, DxColumn, DxEditing, DxSearchPanel, DxCheckBox,
            DxHtmlEditor, DxSelectBox,
            DxToolbar, DxDateBox,
        },
        props: {
            rtgId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        data() {
            return {
                isSaving: false,
                tx: {
                    TabBasicData: this.$LanguageProvider.GetResource("TabBasicData", "Header", "Basisdaten"),
                    TabRights: this.$LanguageProvider.GetResource("TabRights", "Header", "Berechtigungen für öffentliche Bewertung"),
                    FieldName: this.$LanguageProvider.GetResource("FieldName", "Caption", "Name"),
                    FieldDesc: this.$LanguageProvider.GetResource("FieldDesc", "Caption", "Beschreibung"),
                    FieldCaption: this.$LanguageProvider.GetResource("FieldCaption", "Caption", "Überschrift"),
                    FieldEnabled: this.$LanguageProvider.GetResource("FieldEnabled", "Caption", "Aktiviert"),
                    FieldRtgIsPublic: this.$LanguageProvider.GetResource("FieldRtgIsPublic", "Caption", "Öffentliches Voting gemäß Berechtigung"),
                    FieldRatingTypeExGrp: this.$LanguageProvider.GetResource("RatingTypeExGrp", "Caption", "Expertengruppe"),
                    FieldRatingTypeComp: this.$LanguageProvider.GetResource("RatingTypeComp", "Caption", "Kampagne"),
                    FieldRatingTypeTty: this.$LanguageProvider.GetResource("RatingTypeTty", "Caption", "Thementyp"),
                    FieldRatingTypeStatus: this.$LanguageProvider.GetResource("RatingTypeStatus", "Caption", "Status"),
                    FieldRatingTypeStatusGroup: this.$LanguageProvider.GetResource("RatingStatusGrp", "Caption", "Statusgruppe"),
                    FieldRatingTypeOverallQues: this.$LanguageProvider.GetResource("RatingTypeOverallQues", "Caption", "Mit Gesamtfrage"),
                    FieldRatingTypeOverallQuesTitle: this.$LanguageProvider.GetResource("RatingTypeOverallQuesTitle", "Caption", "Titel der Gesamtfrage"),
                    FieldRatingTypeOverallQuesText: this.$LanguageProvider.GetResource("RatingTypeOverallQuesText", "Caption", "Text der Gesamtfrage"),
                    FieldRatingTypeOverallCm: this.$LanguageProvider.GetResource("RatingTypeOverallCm", "Caption", "Mit Gesamtkommentar"),
                    FieldRtgIncludeOnlyEligableScores: this.$LanguageProvider.GetResource("RtgIncludeOnlyEligableScores", "Caption", "Nur als geeignet gekennzeichnete Bewertungen im Durchschnitt berücksichtigen"),
                    FieldRatingTypeStart: this.$LanguageProvider.GetResource("RatingTypeStart", "Caption", "Start"),
                    FieldRatingTypeEnd: this.$LanguageProvider.GetResource("RatingTypeEnd", "Caption", "Ende"),
                },
                column: {
                    ColGroup: this.$LanguageProvider.GetResource("ColGroup", "Caption", "Benutzergruppe"),
                    ColRead: this.$LanguageProvider.GetResource("ColRead", "Caption", "Lesen"),
                    ColEdit: this.$LanguageProvider.GetResource("ColEdit", "Caption", "Bearbeiten"),
                },
                btn: {
                    BtnCancel: this.$LanguageProvider.GetResource("BtnCancel", "Caption", "Abbrechen"),
                    BtnSave: this.$LanguageProvider.GetResource("BtnSave", "Caption", "Speichern"),
                    BtnDelete: this.$LanguageProvider.GetResource("BtnDelete", "Caption", "Löschen"),
                }
            };
        },
        computed: {
            ratingTypeGroupDetail() {
                return this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetail
            },
            ratingTypeGroupDetailIsLoading() {
                return this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetailIsLoading
            },
            ratingTypeGroupDetailText() {
                return JSON.stringify(this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetail)
            },
            accessList() {
                return this.$store.state.ratingTypeGroupStore.accessList
            },
            groupList() {
                return this.$store.state.groupStore.groupListSimple
            },
            roundList() {
                return this.$store.state.roundStore.roundList
            },
            ttyList() {
                return this.$store.state.topicTypeStore.ttySimpleList
            },
            statusList() {
                return this.$store.state.statusStore.statusListWithTty.filter(m => m.TtyId == this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetail.TtyId)
            },
            statusGroupList() {
                return this.$store.state.statusGroupStore.statusGroupListSimple
            },
            accessListIsLoading() {
                return this.$store.state.ratingTypeGroupStore.accessListIsLoading
            },
            accessListText() {
                return JSON.stringify(this.$store.state.ratingTypeGroupStore.accessList)
            },
            saveButtonType() {
                return this.changed ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.changed ? false : true
            },
            changed() {
                return this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetailChanged
                    || this.$store.state.ratingTypeGroupStore.accessListChanged
            },
        },
        created: function () {
            let vm = this
            this.$store.dispatch("getRatingTypeGroupDetail", { rtgId: vm.rtgId })
            this.$store.dispatch("getAccessListForRatingTypeGroup", { rtgId: vm.rtgId })
            this.$store.dispatch("getGroupListSimple")
            this.$store.dispatch("getRoundList")
            this.$store.dispatch("getTtySimpleList")
            this.$store.dispatch("getStatusListWithTty")
            this.$store.dispatch("getStatusGroupListSimple")

        },
        watch: {
            ratingTypeGroupDetailText: function (newVal, oldVal) {
                if (oldVal != "{}" && !this.ratingTypeGroupDetailIsLoading && oldVal != newVal) {
                    this.$store.state.ratingTypeGroupStore.ratingTypeGroupDetailChanged = true
                }
            },
            accessListText: function (newVal, oldVal) {
                if (oldVal != "[]" && !this.accessListIsLoading && oldVal != newVal) {
                    this.$store.state.ratingTypeGroupStore.accessListChanged = true
                }
            },
            changed: function (newVal) {
                if (!newVal && this.isSaving) {
                    this.isSaving = false
                    notify("The changes were saved successfully")
                }
            },
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                this.isSaving = true
                this.$store.dispatch("saveRatingTypeGroupDetail")
                this.$store.dispatch("saveAccessListForRatingTypeGroup")
            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        axios
                            .get(baseUri + '/Delete?rtgId=' + this.rtgId)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
        }
    }


</script>
<style>
</style>
